<div class="container-fluid px-1 px-md-5 px-lg-1 px-xl-5 py-5 mx-auto">
    <div class="card card0 border-0">
        <div class="row d-flex">
            <div class="col-lg-6">
                <div class="card1 pb-5">
                    <div class="row"> <img src="../../../assets/images/logoa.svg"
                            style="width: 90%; margin: auto; padding-top: 20px;"> </div>
                    <div class="row px-3 justify-content-center mt-4 mb-5 border-line"> <img
                            src="../../../assets/images/logo-mini.svg" class="image"> </div>
                </div>
            </div>


            <div class="col-lg-6" style=" margin: auto;">

                <form #ngResetPasswordForm="ngForm" name="form"
                    (ngSubmit)="ngResetPasswordForm.form.valid && onSubmit()" novalidate>
                    <h3>Change Password</h3>
                    <div class="card2 card border-0 px-4 py-5">

                        <div class="row px-3">
                            <label class="mb-1">
                                <h6 class="mb-0 text-sm">Current Password</h6>
                            </label>

                            <input [type]="changetype?'password':'text'" class="form-control" name="currentPassword"
                                [(ngModel)]="currentPassword" required #currentPasswordField="ngModel" />
                                <span class="eyeicon" (click)="viewcurrentpassword()"><i [ngClass]="visible?'fa fa-eye':'fa fa-eye-slash'"></i></span>
                            <div class="alert alert-danger" role="alert"
                                *ngIf="ngResetPasswordForm.submitted && currentPasswordField.errors">
                                <div *ngIf="currentPasswordField.errors['required']">Current Password is required</div>
                            </div>
                        </div>

                        <div class="row px-3">
                            <label class="mb-1">
                                <h6 class="mb-0 text-sm">New Password</h6>
                            </label>

                            <input [type]="newchangetype?'password':'text'" class="form-control" name="password" [(ngModel)]="password" required
                                #passwordField="ngModel" />
                                 <span class="neweyeicon" (click)="showpassword()"><i [ngClass]="showvisible?'fa fa-eye':'fa fa-eye-slash'"></i></span>
                            <div class="alert alert-danger" role="alert"
                                *ngIf="ngResetPasswordForm.submitted && passwordField.errors">
                                <div *ngIf="passwordField.errors['required']">New Password is required</div>
                            </div>
                        </div>

                        <div class="row px-3">
                            <label class="mb-1">
                                <h6 class="mb-0 text-sm">Confirm New Password</h6>
                            </label>

                            <input [type]="newConfirmChangeType?'password':'text'" class="form-control" name="confirmPassword"
                                [(ngModel)]="confirmPassword" required #confirmPasswordField="ngModel" />
                                <span class="newconfirmeyeicon" (click)="showconfirmpassword()"><i [ngClass]="showConfirmVisible?'fa fa-eye':'fa fa-eye-slash'"></i></span>
                            <div class="alert alert-danger" role="alert"
                                *ngIf="ngResetPasswordForm.submitted && confirmPasswordField.errors">
                                <div *ngIf="confirmPasswordField.errors['required']">Confirm New Password is required
                                </div>
                            </div>
                        </div>


                        <div class="row mb-3 px-3"> <button type="submit"
                                class="btn btn-blue text-center">Submit</button> </div>
                    </div>

                </form>
            </div>


        </div>
        <div class="bg-blue py-4">
            <div class="row px-3"> <small class="ml-4 ml-sm-5 mb-2">Copyright &copy; HBM Nigeria Plc {{ today | date
                    : 'yyyy'}}. All rights reserved.</small>
                <div class="social-contact ml-4 ml-sm-auto"> <span class="fa fa-facebook mr-4 text-sm"></span> <span
                        class="fa fa-google-plus mr-4 text-sm"></span> <span class="fa fa-linkedin mr-4 text-sm"></span>
                    <span class="fa fa-twitter mr-4 mr-sm-5 text-sm"><img
                            src="../../../assets/images/holcim_logo_color.svg" alt="" srcset=""
                            style="height: 30px;"></span>
                </div>
            </div>
        </div>
    </div>
</div>